import moment from 'moment'

export const secondsToDateMonth = seconds => moment.utc(moment.unix(seconds)).format('MMM DD')

export const secondsToDateMonthDay = seconds => moment.unix(seconds).format('MMM DD, YYYY')

export const formatDate = date =>  moment.utc(date).format('MMM DD')

export const convertToUTC = date => moment.utc(`${date.format('YYYY')}-${date.format('MM')}-${date.format('DD')}`).toDate()

export const toChatDateFormat = seconds => {
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    let day = ''

    if(moment(seconds).isSame(today, 'd')){
        day = 'Today'
    }
    if(moment(seconds).isSame(yesterday, 'd')){
        day = 'Yesterday'
    }

    if(day) {
        return day + ' | ' + moment.unix(seconds / 1000).format('h:mm A')
    }

    return moment.unix(seconds / 1000).format('MMM DD, YYYY | h:mm A')
}

export const subscriptionEndingDateFormat = seconds => {
    return moment.unix(seconds / 1000).format('h:mm A, MMM DD, YYYY')
}


